export default {
    activated: 'Activée',
    active: 'Active',
    applyAndReload: 'Appliquer et rafraîchir',
    autoActivated: 'Activée automatiquement',
    availableSince: 'Disponible depuis le {0}',
    browserNotSupportingVideoPlaying: 'Votre navigateur ne supporte pas la lecture vidéo.',
    deactivateWithoutComment: 'Désactiver sans commentaire',
    deactivated: 'Désactivée',
    giveFeedback: 'Donner votre avis',
    leaveAComment: 'Laisser un commentaire',
    newTag: 'Nouveau',
    noComment: 'Pas de commentaire',
    notAutoActivated: "N'est pas activée automatiquement",
    projectedAdoptionOn: 'Adoption projetée au {0}',
    requestFeedback: 'Avant de désactiver {0}, souhaitez-vous nous faire part de vos commentaires?',
    theF: 'la',
    theM: 'le',
    title: 'Aperçu des fonctionnalités',
    willBe: 'Sera',
    newLeadPage: {
        description1:
            'Nous sommes ravis de vous annoncer une mise à jour majeure de la page Lead. Nous avons entièrement revu cette page pour la rendre plus conviviale et efficace.',
        description2: 'Voici les principaux changements :',
        change1: 'Un nouvel agencement plus intuitif et facile à naviguer',
        change2: 'Une fonctionnalité de filtrage améliorée',
        change3: 'De nouveaux éléments visuels et des mises à jour de design',
        change4: 'Et bien plus...',
        conclusion:
            "Nous espérons que ces changements faciliteront votre recherche et votre gestion de vos leads. N'hésitez pas à nous faire part de vos commentaires ou de vos questions sur cette mise à jour. Merci d'utiliser Activix CRM !",
    },
    leadPageV3: {
        description1: "Fiche Lead V3 avec processus d'achat combiné",
        description2:
            'Ceci va automatiquement activer la nouvelle fiche lead sur laquelle la V3 dépend.',
    },
};
